import React from "react";

import { getTestAttributes } from "@common/utils/tests";
import { Button } from "@common/components/Button";
import { SkipLogicInternalControl } from "../../controls";

import "./controls.styles.scss";

type SkipLogicControlsProps = {
  controls: Array<SkipLogicInternalControl>;
};

export const SkipLogicControls: React.FC<SkipLogicControlsProps> = ({ controls }) => {
  return (
    <div className="SkipLogic__controls">
      {controls.map((x, i) => {
        const tooltip = x.tooltip || "";
        return (
          <div
            key={i}
            className="SkipLogic__controls__btn-wrapper"
            title={tooltip}
          >
            <Button
              {...getTestAttributes('SkipLogic', x.description, "button")}
              className="SkipLogic__controls__btn SkipLogic-controls-move-up"
              onClick={x.handler}
              disabled={x.disabled}
              style={{ pointerEvents: x.disabled ? "none" : "auto" }}
            >
              <img className="SkipLogic__controls__icon" src={x.iconSrc} />
            </Button>
          </div>
        );
      })}
    </div>
  );
};
